import React from 'react'
import { Box, Divider, Flex, Text, HStack, Tooltip } from '@chakra-ui/react'
import { pluralize } from 'utils/functions/formatString'
import currencySymbol from 'utils/functions/currencySymbolMap/currencySymbol'
import { AlertTriangle } from 'react-feather'
import { IDashboardPlan } from 'services/IApi.d'
import { InfoOutlineIcon } from '@chakra-ui/icons'

interface Props {
  data?: IDashboardPlan | any
}

const PlanResume: React.FC<Props> = ({ data = {
  name: '',
  services: null,
  serviciosGratuitos: null,
  additionalServices: '',
  price: '',
  physicalSubscriptionsQuantity: null,
  banks: null,
  type: ''
}, }) => {
  const { name: planName, services: serviciosPlan, additionalServices: serviciosAdicionales, price: precioTotal, physicalSubscriptionsQuantity: nroBancoSuscripcionFisica, type } = data
  const price = precioTotal === '0' ? 'Sin costo' : `${currencySymbol('$')} ${Number(precioTotal).toLocaleString('es-AR')} `
  const isAdditionalServices = serviciosAdicionales !== '0 servicios'
  const isAdditionalServicesFijo = type === 'fijo' 

  return (
    <Flex alignItems='center'>
      <Box mr='8'>
        <Text mb='4' textStyle='h6' color='tertiary.500'>
          Plan {planName}
        </Text>

        {serviciosPlan &&
          <HStack mb='1' gap='20px'>
            <Text minW='160px' textStyle='labelLg' color='grey.120'>
              Elegiste para tu plan
            </Text>

            <Text textAlign='right' textStyle='labelLgBold' minW='160px' color='grey.120'>
              {serviciosPlan}
            </Text>
            <Box>
              {nroBancoSuscripcionFisica !== '0' &&
                <Box fontSize='12px'>
                  <Flex alignItems='start'>
                    <AlertTriangle size='16px' />
                    <Box ml='1' lineHeight={1.2}>
                      <Text>
                        {nroBancoSuscripcionFisica} {pluralize(nroBancoSuscripcionFisica, 'banco', 's')} {pluralize(nroBancoSuscripcionFisica, 'requiere', 'n')} suscripción física
                      </Text>
                    </Box>
                  </Flex>
                </Box>
              }
            </Box>
          </HStack>
        }

        {isAdditionalServices &&
          <HStack gap='20px' pb='8px'>
            <Text minW='160px' textStyle='labelLg' color='grey.120'>
              Servicios adicionales
            </Text>

            <Text textStyle='labelLgBold' textAlign='right' minW='160px' color='grey.120'>
              {serviciosAdicionales}
            </Text>
          </HStack>
        }
        
        <HStack gap='20px' borderTop='1px solid' borderTopColor='grey.50' pt='8px'>
          <Text minW='160px' textStyle='bodyLgBold' color='grey.120'>
            {isAdditionalServicesFijo || !isAdditionalServices ? 'Precio final' : 'Precio inicial'}
          </Text>

          <Flex minW='160px' align='center' justifyContent='flex-end'>
            <Box textStyle='h6' textAlign='right' color='grey.120'>{price}</Box>
            &nbsp;
            <Box textStyle='labelMdBold' color='grey.120'>+IVA por mes</Box>
          </Flex>
          {type === 'variable' &&
            <Tooltip p={1} label='Precio variable sujeto a condiciones de los servicios adicionales' aria-label='A tooltip'
              placement='top'>
              <InfoOutlineIcon color='grey.120' data-testid="tooltip-element" mx={2} />
            </Tooltip>
          }
        </HStack>
      </Box>
    </Flex>
  )
}

export default PlanResume
